// クリップボードコピー
import commonClass from "./commonClass";

export default class copyToClipboardClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$btn = $('.js-copy-to-clipboard');
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    this._$btn.on('click',function () {
      var cls = this;
      // コピー対象を定義
      var copy_tgt = $(cls).parents('.c-copy').find('.c-copy_tgt')[0];
      // コピー対象のテキストを選択(disable:noneでもコピー可とする)
      //copy_tgt.select();
      var textarea = document.createElement("textarea")
      textarea.value = copy_tgt.value
      document.body.appendChild(textarea)
      textarea.select()

      // 選択しているテキストをクリップボードにコピーする
      // document.execCommand("Copy");
      if (textarea.value == '') {
        var guide = '選択エラー';
        var lead = 'メール本文が未入力のため、コピーすることができませんでした';
        common_confirm_c_modal('common_confirm_c', guide, lead, '', '', 'info', '/img/icon_error.svg');
      } else {
        document.execCommand("Copy");
      }
      document.body.removeChild(textarea);
    });
  }

}